import * as faceapi from '@vladmandic/face-api/dist/face-api.esm-nobundle.js'

const MODEL_URL = process.env.PUBLIC_URL + '/models'

let loadPromise = null

// Shared face tracker used by the Execute engine. Wraps face-api's
// TinyFaceDetector (the browser's native FaceDetector is unavailable in most
// browsers, which is why face tracking previously never produced data).
export function createFaceTracker() {
    let options = null
    let loaded = false

    return {
        async load() {
            if (loaded) return
            if (!loadPromise) {
                loadPromise = faceapi.nets.tinyFaceDetector.loadFromUri(
                    MODEL_URL
                )
            }
            await loadPromise
            options = new faceapi.TinyFaceDetectorOptions({
                inputSize: 320,
                scoreThreshold: 0.4,
            })
            loaded = true
        },

        // Returns the largest face box in normalized (0-1) video space, or null.
        async detect(video) {
            if (!loaded || !video) return null
            const dets = await faceapi.detectAllFaces(video, options)
            if (!dets.length) return null
            let best = dets[0]
            let bestArea = 0
            for (const d of dets) {
                const b = d.box || d.detection?.box || {}
                const area = (b.width || 0) * (b.height || 0)
                if (area > bestArea) {
                    bestArea = area
                    best = d
                }
            }
            const b = best.box || best.detection?.box || {}
            const vw = video.videoWidth || 1
            const vh = video.videoHeight || 1
            return {
                x: b.x / vw,
                y: b.y / vh,
                w: b.width / vw,
                h: b.height / vh,
                score: best.score,
            }
        },
    }
}
